<template>
  <footer class="footer">
    <div class="footer-content">
      <p>&copy; {{ currentYear }} Prec8. All rights reserved.</p>
      <div class="footer-links">
        <button @click="goToPrivacyPolicy" class="footer-link">Privacy Policy</button>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  components: {},
})
export default class Footer extends Vue {
  get currentYear() {
    return new Date().getFullYear()
  }

  goToPrivacyPolicy() {
    this.$router.push('/privacy-policy')
  }

  mounted() {
    console.log('Footer component loaded')
  }
}
</script>

<style scoped>
.footer {
  background: #f8fafc;
  padding: 1.5rem 0;
  color: #666;
  border-top: 1px solid #e1e5e9;
  z-index: 200;
  min-height: 60px;
  width: 100%;
  flex-shrink: 0;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.footer-links {
  display: flex;
  gap: 1rem;
}

.footer-link {
  background: none;
  border: none;
  color: #666;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  text-decoration: none;

  &:hover {
    background: #e1e5e9;
    color: #1a1a1a;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 1rem;
  }

  .footer-content {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }
}
</style> 